import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { DestinationsSection } from '../components/home/DestinationsSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { StatsSection } from '../components/home/StatsSection';
import { CTASection } from '../components/home/CTASection';
import { motion } from 'framer-motion';
export function HomePage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-474">
      <HeroSection data-id="element-475" />
      <StatsSection data-id="element-476" />
      <DestinationsSection data-id="element-477" />
      <ServicesSection data-id="element-478" />
      <TestimonialsSection data-id="element-479" />
      <CTASection data-id="element-480" />
    </motion.div>;
}